<template>

  <!--相当于a标签 to="path"-->
  <!-- <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </nav> -->
  <!--展示内容-->
  <router-view />

</template>

<script>
  import { useI18n } from 'vue-i18n'
  // import {provide} from 'vue'
  // import * as echarts from 'echarts'

  export default ({
    name: 'App',
    setup() {

      const { t, locale } = useI18n({
        inheritLocale: true,
        useScope: 'global'
      })
      return {
        t, locale
      }
    }

  })
</script>
<style lang="scss">
  /* ===== 主题变量：浅色（默认，顶栏/导航也为浅色）===== */
  :root {
    /* 全局字号：Element Plus 默认 14px，统一缩小一级 */
    --app-font-size: 13px;
    --el-font-size-extra-large: 18px;
    --el-font-size-large: 16px;
    --el-font-size-medium: 14px;
    --el-font-size-base: 13px;
    --el-font-size-small: 12px;
    --el-font-size-extra-small: 11px;
    --app-bg: #f5f7fa;
    --header-bg: #f5f7fa;
    --header-text: #303133;
    --side-bg: #f5f7fa;
    --side-text: #303133;
    --side-hover: #e4e7ed;
    --side-active: #409eff;
    --side-active-bg: rgba(64, 158, 255, 0.12);
    --border: #e4e7ed;
    --border-light: #ebeef5;
    --hover-bg: #f5f7fa;
    --active-bg: #ecf5ff;
    --text-weak: #909399;
    --panel-bg: #fafbfc;
    --content-bg: #ffffff;
    --text-main: #303133;
    --text-sub: #606266;
  }
  /* ===== 深色主题（DeepSeek 深色界面）===== */
  html.theme-dark {
    --app-bg: #17171b;
    --header-bg: #17171b;
    --header-text: #e6e6e6;
    --side-bg: #0f0f12;
    --side-text: #d1d1d6;
    --side-hover: #232326;
    --side-active: #7a8bff;
    --side-active-bg: rgba(122, 139, 255, 0.18);
    --border: #2a2a2e;
    --border-light: #2c2c30;
    --hover-bg: #232328;
    --active-bg: rgba(64, 158, 255, 0.15);
    --text-weak: #6e6e73;
    --panel-bg: #232328;
    --content-bg: #1e1e22;
    --text-main: #e6e6e6;
    --text-sub: #9a9a9e;
    /* Element Plus 组件深色变量 */
    --el-bg-color: #1e1e22;
    --el-bg-color-overlay: #26262b;
    --el-fill-color-blank: #1e1e22;
    --el-fill-color: #26262b;
    --el-fill-color-light: #232328;
    --el-fill-color-lighter: #202025;
    --el-fill-color-extra-light: #1e1e22;
    --el-fill-color-dark: #333338;
    --el-fill-color-darker: #3a3a40;
    --el-border-color: #3a3a40;
    --el-border-color-light: #3a3a40;
    --el-border-color-lighter: #333338;
    --el-border-color-extra-light: #2c2c30;
    --el-text-color-primary: #e6e6e6;
    --el-text-color-regular: #d1d1d6;
    --el-text-color-secondary: #9a9a9e;
    --el-scrollbar-bg-color: rgba(255, 255, 255, 0.28);
  }

  html,
  body {
    padding: 0;
    margin: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    font-size: var(--app-font-size) !important;
    background-color: var(--app-bg) !important;
  }

  #app {
    width: 100%;
    height: 100%;
  }

  #app,
  button,
  input,
  textarea,
  select {
    font-size: var(--app-font-size);
  }

  /* Element Plus 少数组件使用固定字号，跟随全局基础字号 */
  .el-menu-item,
  .el-sub-menu__title,
  .el-breadcrumb,
  .el-form-item__label,
  .el-table,
  .el-dialog,
  .el-message-box,
  .el-dropdown-menu__item {
    font-size: var(--app-font-size);
  }

  /* ===== 滚动条跟随深浅主题 ===== */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background: #c0c4cc;
    border-radius: 4px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #909399;
  }
  ::-webkit-scrollbar-track {
    background: transparent;
  }
  html.theme-dark ::-webkit-scrollbar-thumb {
    background: #3a3a40;
  }
  html.theme-dark ::-webkit-scrollbar-thumb:hover {
    background: #4a4a52;
  }
  html.theme-dark ::-webkit-scrollbar-track {
    background: transparent;
  }

  /* ===== 深色下 markdown 预览区配色 ===== */
  html.theme-dark .markdown-body {
    color: #d1d5db;
  }
  html.theme-dark .markdown-body h1,
  html.theme-dark .markdown-body h2,
  html.theme-dark .markdown-body h3,
  html.theme-dark .markdown-body h4,
  html.theme-dark .markdown-body h5,
  html.theme-dark .markdown-body h6 {
    color: #e6e6e6;
    border-color: #3a3a40;
  }
  html.theme-dark .markdown-body blockquote {
    color: #9a9a9e;
    border-color: #4a4a52;
    background: #232328;
  }
  html.theme-dark .markdown-body code {
    background: rgba(255, 255, 255, 0.08);
    color: #f97583;
  }
  html.theme-dark .markdown-body pre {
    background: #232328;
  }
  html.theme-dark .markdown-body pre code {
    color: #d1d5db;
  }
  html.theme-dark .markdown-body table th,
  html.theme-dark .markdown-body table td {
    border-color: #3a3a40;
  }
  html.theme-dark .markdown-body hr {
    background-color: #3a3a40;
  }

  /* ===== 深色下 Vditor 编辑器（周报页）===== */
  html.theme-dark .vditor-wrap .vditor {
    background: var(--content-bg) !important;
    border-color: var(--border-light) !important;
  }
  html.theme-dark .vditor-wrap .vditor-toolbar {
    background: var(--panel-bg) !important;
    border-color: var(--border-light) !important;
  }
  html.theme-dark .vditor-wrap .vditor-content,
  html.theme-dark .vditor-wrap .vditor-ir,
  html.theme-dark .vditor-wrap .vditor-textarea,
  html.theme-dark .vditor-wrap .vditor-preview {
    background: var(--content-bg) !important;
    color: var(--text-main) !important;
  }

  /* ===== 深色下 wangeditor 富文本编辑器（在线文档页）===== */
  html.theme-dark .w-e-toolbar {
    background: var(--panel-bg) !important;
    border-color: var(--border-light) !important;
  }
  html.theme-dark .w-e-bar-item button,
  html.theme-dark .w-e-bar-item .w-e-select {
    color: var(--text-sub) !important;
  }
  html.theme-dark .w-e-bar-item button:hover,
  html.theme-dark .w-e-bar-item button:focus {
    background: var(--hover-bg) !important;
    color: var(--text-main) !important;
  }
  html.theme-dark .w-e-select-list,
  html.theme-dark .w-e-drop-panel,
  html.theme-dark .w-e-modal,
  html.theme-dark .w-e-hover-bar,
  html.theme-dark .w-e-menu-tooltip-v5 {
    background: var(--el-bg-color-overlay) !important;
    color: var(--text-main) !important;
    border-color: var(--border-light) !important;
  }
  html.theme-dark .w-e-select-list .w-e-select-item:hover,
  html.theme-dark .w-e-drop-panel .w-e-drop-panel-content .w-e-bar-item:hover {
    background: var(--hover-bg) !important;
    color: var(--text-main) !important;
  }
  html.theme-dark .w-e-text-container {
    background: var(--panel-bg) !important;
  }
  html.theme-dark .w-e-text-container [contenteditable="true"] {
    color: var(--text-main) !important;
    caret-color: var(--text-main) !important;
  }
  html.theme-dark .w-e-text-placeholder {
    color: var(--text-weak) !important;
  }
  html.theme-dark .w-e-modal input,
  html.theme-dark .w-e-modal textarea,
  html.theme-dark .w-e-modal select {
    background: var(--panel-bg) !important;
    color: var(--text-main) !important;
    border-color: var(--border-light) !important;
  }

  .flex-flaot {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .flex {
    display: flex;
    align-items: center;
  }

  .page_content {
    display: block;
    width: 100%;
    height: 100%;
    min-width: 0;
    min-height: 0;
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    overflow: auto;
    background-color: var(--content-bg);

  }

  .page_content.page-flex-layout {
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .content_breadcrumb{
    min-height: 42px;
    display: flex;
    flex: 0 0 auto;
    align-items: center;
    box-sizing: border-box;
    padding: 8px 12px;
    margin-bottom: 8px;
    color: wheat;
    border-bottom: 1px solid rgb(153, 152, 152);
  }

  .content_main {
    display: flex;
    flex: 1;
    min-width: 0;
    min-height: 0;
    flex-direction: column;
    overflow: hidden;
  }

  .page-table-area {
    flex: 1;
    min-width: 0;
    min-height: 0;
    overflow: hidden;
  }

  .page-pagination {
    display: flex;
    flex: 0 0 auto;
    justify-content: center;
    position: relative;
    box-sizing: border-box;
    padding: 8px 0;
  }

  .page-size-select {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: var(--text-sub);
    font-size: 13px;
    white-space: nowrap;
    z-index: 1;
  }

  .query-date-picker {
    width: 360px !important;
    flex: 0 0 360px !important;
  }

  /* 错误信息统一写入服务器日志，不再显示页面错误气泡。 */
  .el-message.el-message--error {
    display: none !important;
  }

</style>
